import { createSelector } from 'reselect'
import { AVAILABILITY_STATE } from './constants'
import { getCurrency } from 'src/comps/Page/selectors'

export const getIsFetching = state => state[AVAILABILITY_STATE].isFetching
export const getIsBookingRulesLoading = state => state[AVAILABILITY_STATE].isBookingRulesLoading
export const getRoomsBoards = state => state[AVAILABILITY_STATE].boards
export const getRoomsRequested = state => state[AVAILABILITY_STATE].meta?.roomsRequested
export const getBookingRulesRequested = state => state[AVAILABILITY_STATE].rulesComplete

export const getSubtotal = state => state[AVAILABILITY_STATE].meta?.bestPriceData?.subtotal
export const getRoomsCount = state => state[AVAILABILITY_STATE].meta?.bestPriceData?.roomsCount
export const getIsPrime = state => state[AVAILABILITY_STATE].meta?.bestPriceData?.isPrime
export const getIsMobile = state => state[AVAILABILITY_STATE].meta?.bestPriceData?.isMobile

export const getBestPricePerNight = state => state[AVAILABILITY_STATE].meta?.bestPriceData?.perNight

export const getBestPriceTotalDiscount = state =>
  state[AVAILABILITY_STATE].meta?.bestPriceData?.totalDiscounted

export const getBestPriceBeforeDiscount = state =>
  state[AVAILABILITY_STATE].meta?.bestPriceData?.totalBeforeDiscount

export const getBestPriceWithFees = state =>
  state[AVAILABILITY_STATE].meta?.bestPriceData?.totalWithFees

export const getBestPricePerNightWithFees = state =>
  state[AVAILABILITY_STATE].meta?.bestPriceData?.pricePerNightWithFees

export const getBestPricePerNightSubtotal = state =>
  state[AVAILABILITY_STATE].meta?.bestPriceData?.pricePerNightSubtotal

export const getBestPriceSubtotalWithFees = state =>
  state[AVAILABILITY_STATE].meta?.bestPriceData?.subtotalWithFees

export const getBestPriceSubtotalWithFeesNightly = state =>
  state[AVAILABILITY_STATE].meta?.bestPriceData?.subtotalNightlyWithFees

export const getPropertyPricing = createSelector(
  [getBestPriceBeforeDiscount, getBestPriceTotalDiscount, getBestPricePerNight],
  (initialBestPrice, totalDiscount, bestPricePerNight) => ({
    initialBestPrice,
    totalDiscount,
    bestPricePerNight,
  })
)

export const getBestPrice = createSelector(
  [
    getBestPriceTotalDiscount,
    getBestPriceBeforeDiscount,
    getBestPricePerNight,
    getIsPrime,
    getIsMobile,
    getBestPriceWithFees,
    getBestPricePerNightWithFees,
    getBestPricePerNightSubtotal,
    getSubtotal,
    getBestPriceSubtotalWithFees,
    getBestPriceSubtotalWithFeesNightly,
  ],
  (
    price,
    priceBefore,
    pricePerNight,
    isPrime,
    isMobile,
    priceWithFees,
    pricePerNightWithFees,
    pricePerNightSubtotal,
    subtotal,
    subtotalWithFees,
    subtotalNightlyWithFees
  ) => {
    return {
      price,
      priceBefore,
      pricePerNight,
      isPrime,
      isMobile,
      priceWithFees,
      pricePerNightWithFees,
      pricePerNightSubtotal,
      subtotal,
      subtotalWithFees,
      subtotalNightlyWithFees,
    }
  }
)

export const getRoomsByAvailability = createSelector(getRoomsBoards, rooms => {
  const roomsPaxes = rooms.map(room => room.paxesId)
  const uniquePaxesId = [...new Set(roomsPaxes)]

  return uniquePaxesId.map(paxId => rooms.filter(room => room.paxesId === paxId))
})

export const getBoardCurrency = createSelector(
  [getRoomsBoards, getCurrency],
  (boards, defaultCurrency) => {
    return boards[0]?.currency || defaultCurrency
  }
)

export const getIsPrimeBestPrice = createSelector(getRoomsBoards, boards => {
  return boards[0]?.isPrime || false
})

export const getIsMobileBestPrice = createSelector(getRoomsBoards, boards => {
  return boards[0]?.isMobile || false
})
